import type { FC } from "react";
import React from "react";

import type { GtmSdk } from "..";
import { GtmContext } from "./context";

interface GtmSdkProviderProps {
  sdk: GtmSdk;
  children: React.ReactNode;
}

export const GtmProvider: FC<GtmSdkProviderProps> = ({ sdk, children }) => {
  return <GtmContext.Provider value={{ sdk }}>{children}</GtmContext.Provider>;
};
